<template>
  <div>
    <div class="filter-box" style="position: absolute;top: 0; right: 0">
      <span>筛选：</span>
      <a-select show-search option-filter-prop="children" placeholder="请选择课程" v-model="classCourseId">
        <a-select-option :value="joinId(item.classesId, item.planclassesId)" v-for="(item) in classesList" :key="joinId(item.classesId, item.planclassesId)">
          {{ item.classesName }}
        </a-select-option>
      </a-select>
      <!-- <a-button type="primary" class="quiz" @click="quiz">提问</a-button> -->
    </div>
    <div class="comments">
      <z-pagination :spinning="spinning" :enptyImage="enptyImage" :total="total" @loadData="loadData" :desc="desc">
        <comment v-for="item in postList" :key="item.id" :commentData="item" :infoOpers="['del', 'watch', 'like', 'reply']" @onDelete="onDelete">
        </comment>
      </z-pagination>
    </div>
    <!-- <a-spin :spinning="spinning">
      <div class="comments" v-show="postList.length > 0">
        <comment
          v-for="item in postList"
          :key="item.id"
          :commentData="item"
          :opers="['del']"
          @onDelete="onDelete"></comment>
        <a-pagination
          :defaultPageSize="params.limit"
          v-model="current"
          :total="total"
          show-less-items
        />
      </div>
    </a-spin>
    <a-empty
      v-if="empty"
      image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
    /> -->
    <z-modal destroyOnClose :loading="loading" :visible="visible" title="新建提问" :width="434" @close="visible = false" @submit="addQa">
      <a-form-model ref="addForm" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="问题归属" prop="planclassesId">
          <a-select show-search option-filter-prop="children" placeholder="请选择" style="width: 100%" @change="selectChange">
            <a-select-option :value="joinId(item.classesId, item.planclassesId)" v-for="item in addClassesList" :key="joinId(item.classesId, item.planclassesId)">
              {{ item.classesName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="内容" prop="content">
          <a-input v-model="form.content" type="textarea" :rows="6" />
        </a-form-model-item>
        <a-form-model-item label="图片">
          <upload listType="picture-card" path="img/art/" @uploadChange="uploadChange"></upload>
        </a-form-model-item>
      </a-form-model>
    </z-modal>
  </div>
</template>
<script>
import comment from '../components/Comment'
import zPagination from '@/components/ZPagination'
import zModal from '@/components/ZModal'
import upload from '@/components/Upload'
import { findClassesDetail, addTheme, deleteTheme } from '@/api/myQa'
import { getClassesList } from '@/api/user'
const enptyImage = require('@/assets/course_empty.png')

export default {
  name: '',
  data() {
    return {
      desc: '暂无帖子~',
      current: 1,
      enptyImage,
      visible: false,
      loading: false,
      classCourseId: '-', // 列表班级课程id
      params: { // 获取贴子列表参数
        limit: 10,
        page: 0,
        meFlag: 1,
        planclassesId: '',
        classesId: ''
      },
      total: -1,
      postList: [],
      classesList: [
        {
          classesId: '',
          classesName: '全部',
          planclassesId: '',
        }
      ],
      addClassesList: [],
      spinning: false,
      empty: false,
      form: { // 添加贴子表单
        planclassesId: '',
        content: '',
        classesId: '',
        classCourseId: ''
      },
      rules: {
        content: [{ required: true, message: '提问内容不能为空', trigger: 'blur' }],
        planclassesId: [{ required: true, message: '请选择问题归属', trigger: 'blur' }]
      }
    }
  },
  components: {
    comment,
    zPagination,
    zModal,
    upload
  },
  watch: {
    // 'params.classesId'(val, oldVal) {
    //   if (!oldVal) return
    //   const { classesName, ...data } = this.classesList.find(item => item.classesId === val)
    //   // console.log(data)
    //   this.form.classesId = data.classesId
    //   Object.assign(this.params, data)
    //   this.findClassesDetailAsync(this.params)
    // },
    'form.classCourseId'(val, oldVal) {
      // if (!oldVal) return
      const data = this.splitId(val)
      Object.assign(this.form, data)
    },
    classCourseId(val) {
      // this.form.classCourseId = val
      // console.log(this.form)
      const data = this.splitId(val)
      Object.assign(this.params, data)
      this.findClassesDetailAsync(this.params)
    },
    visible(val) {
      if (!val) {
        if (this.form.content) {
          this.form.content = ''
          //   this.form.planclassesId = ''
          //   this.params.page = 0
          //   this.findClassesDetailAsync(this.params)
        }
      } else {
        // this.form.classCourseId = this.classCourseId
      }
    }
  },
  async created() {
    await this.getClassesListAsync()
    this.findClassesDetailAsync(this.params)
  },
  methods: {
    selectChange(ev) {
      this.form.classCourseId = ev
    },
    joinId(classesId, planclassesId) {
      // if (!classesId && !planclassesId) {
      //   this.classCourseId = ''
      //   return ''
      // }
      return `${classesId}-${planclassesId}`
    },
    splitId(strId) {
      const arr = strId.split('-')
      const classesId = arr[0]
      const planclassesId = arr[1]
      return { classesId, planclassesId }
    },
    loadData(val) {
      this.params.page = parseInt(val) - 1
      this.findClassesDetailAsync(this.params)
    },
    // 获取学员所有课程
    async getClassesListAsync() {
      try {
        const res = await getClassesList()
        // console.log(res)
        this.classesList.push(...res)
        this.addClassesList = res
        if (res.length) {
          this.classCourseId = this.joinId(this.classesList[0].classesId, this.classesList[0].planclassesId)
        } else {
          this.spinning = false
          this.empty = true
          this.postList = []
          this.total = 0
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取贴子列表
    async findClassesDetailAsync(params) {
      try {
        this.spinning = true
        // 总数 themeNum
        const { list, themeNum } = await findClassesDetail({
          ...params,
          // planclassesId: '499cf18ff10e18a206704f886ca41022',
          // classesId: '7439eac1802fafe8eecdd9d733ea971'
        })
        this.postList = list
        this.total = themeNum
        // console.log(this.postList, themeNum)
      } catch (error) {
        console.log(error)
        this.postList = []
        this.total = 0
      } finally {
        this.spinning = false
      }
    },
    // 删除贴子
    async onDelete({ id }) {
      try {
        this.spinning = true
        const res = await deleteTheme(id)
        if (res) {
          this.$message.success('删除成功')
          this.findClassesDetailAsync(this.params)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.spinning = false
      }
    },
    // 新增贴子
    addQa() {
      console.log('add', this.form)
      this.$refs.addForm.validate(async valid => {
        try {
          if (valid) {
            this.loading = true
            const res = await addTheme(this.form)
            res && this.$message.success('发布成功')
            this.findClassesDetailAsync(this.params)
            this.visible = false
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      })
    },
    quiz() {
      this.visible = true
    },
    uploadChange(ev) {
      this.form.photos = ev.join(',')
    }
  }
}
</script>
<style lang="less" scoped>
.filter-box {
  /deep/ .ant-select-selection {
    width: 220px;
background: #F5F7FA;
border-radius: 4px;
border: none;
  }
}
.comments {
  padding-bottom: 28px;

  .ant-pagination {
    margin-top: 18px;
    text-align: center;
  }
}

.quiz {
  margin-left: 12px;
  border-radius: 3px;
  // background-color: #1564ff;
}

.ant-form {

  // margin-top: 16px;
  .ant-input {
    background: #FFF;
    border-radius: 4px;
    border: 1px solid #DCDCDC;
    ;
    padding-top: 12px;
  }
}

.ant-spin-nested-loading {
  min-height: 200px;
}

/deep/.ant-select-selection {
  border-radius: 4px;
}
</style>
